<section class="section-welcome container">
    <div class="left">
        <h1>Como tratamos seus dados</h1>
        <p>Proteção de dados pessoais estão no centro de tudo o que fazemos. Saiba mais sobre como tratamos dados pessoais.</p>
    </div>
    <div class="right hidden-xs">
        <img src="assets/illustration-notebook-2.svg" alt="Ilustração - Conheça seus direitos">
    </div>
</section>
<section class="container">
    <p class="note">A <strong>Serasa Experian</strong>, líder em serviços de informação e responsável pela maior base de dados da América Latina, mantém um forte compromisso com a educação e conscientização do mercado e dos titulares acerca do tratamento de dados pessoais, prezando sempre pelas melhores práticas em governança de dados e segurança da informação.<br>Saiba mais sobre como realizamos a coleta, a utilização, o fornecimento e o armazenamento das suas informações em consonância com o que determina a legislação de proteção de dados pessoais.</p>
    <div class="cards-list container">
        <div class="card-area" *ngFor="let card of cardList">
            <app-card-link class="{{card.id}}" [cardTitle]="card.titulo" [cardDescription]="card.descricao"></app-card-link>
        </div>
    </div>
</section>
<section class="purple-area">
    <div class="container">
        <div class="content">
            <div class="left">
                <img src="assets/illustration-security.svg" alt="Ilustração - Cofre">
            </div>
            <div class="right">
                <h2>Entenda de quais fontes podemos coletar ou receber dados sobre você</h2>
                <p>Os bancos de dados da Serasa Experian são compostos por dados provenientes de diferentes fontes. Assim, se mantivermos dados pessoais sobre você, esses podem ser provenientes de uma ou mais fontes, como as relacionadas abaixo:</p>
                <ul>
                    <li>Cadastro criado por você no site Serasa ou em uma de nossas soluções;</li>
                    <li>Clientes e parceiros de todos os ramos de negócios com os quais você tem ou teve um relacionamento comercial, como instituições financeiras, empresas de telecomunicações, concessionárias de serviços de luz, água e esgoto, varejistas, seguradoras e indústrias;</li>
                    <li>Empresas especializadas em fornecimento de dados, que atuem em conformidade com a legislação brasileira;</li>
                    <li>Repositórios publicamente disponíveis mantidos por órgãos da Administração Pública Direta ou Indireta;
                    </li>
                    <li>Repositórios disponíveis para consultas ao público, como websites sem restrição de acesso. Esses dados podem ser recebidos pela Serasa Experian, como no caso daqueles provenientes de clientes e fornecedores, ou coletados pela Serasa Experian, como acontece, por exemplo, em relação aos websites, sempre observando a legislação vigente.</li>
                </ul>
            </div>
        </div>
    </div>
</section>
<app-footer-lgpd></app-footer-lgpd>
<app-modal-sidebar></app-modal-sidebar>